import React, { useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const RowAsignatura = ({
  id,
  titulo,
  estado,
  ciclo,
  vez,
  creditos,
  nomTooltip,
  binscrito,
}) => {
  let { setIdAsignaturas } = useMatricula();
 
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
   
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_ciclo: obtenerLabelEtiqueta(
          "lbl_global_ciclo",
          listadoEtiquetas
        ),
        global_vez: obtenerLabelEtiqueta("lbl_global_vez", listadoEtiquetas),
        global_sumilla: obtenerLabelEtiqueta(
          "lbl_global_sumilla",
          listadoEtiquetas
        ),
        horario_creditos: obtenerLabelEtiqueta(
          "lbl_horario_creditos",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { global_ciclo, global_vez, global_sumilla, horario_creditos } =
    etiquetas;

  const splitTitle = (position) => {
    const resultSplit = titulo.split("-");
    
    let result = "";
    if (position === 0) {
      result = resultSplit[0];
    } else {
      result = resultSplit[1];
    }

    return result;
  };
  return (
    <div
      className={`d-flex asig-list va-middle mb-3 course-info-2  ${
        binscrito ? "course-selected" : ""
      }`}
    >
      <p className=" fw-medium w-50 fs-sm mb-0">
        {/* {titulo} */}
        <span className="text-uppercase fw-bolder">{splitTitle(0)}</span>
        {" - " + splitTitle(1)}

       { binscrito ? (<i className="bi bi-check-circle ms-1"></i>):''} 
      </p>
      <div className="w-50 d-flex justify-content-end">
      

        {
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id={estado}>{nomTooltip}</Tooltip>}
          >
            <button
              className={`
              ms-3 fs-sm 
              ${
                estado === "C"
                  ? "icon-com"
                  : estado === "E"
                  ? "icon-ele"
                  : estado === "O"
                  ? "icon-obli"
                  : ""
              }`}
            >
              <span variant="secondary">{estado}</span>{" "}
            </button>
          </OverlayTrigger>
        }

        <p className="w-25  mb-0 fs-sm fw-medium text-end">
          Nivel: {ciclo}
        </p>

        <p className="w-25 mb-0 fs-sm fw-medium text-center">
          {global_vez}: {vez}
        </p>
        <div className="w-25  d-flex">
          <p className="mb-0 fs-sm fw-medium">{global_sumilla}: </p>
          <button
            className="btn btn-sumilla"
            data-bs-toggle="modal"
            data-bs-target="#sumilla"
            onClick={() => {
              setIdAsignaturas(id);
            }}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.01675 4.71675H7.31675V3.41675H6.01675M6.66675 11.8667C3.80025 11.8667 1.46675 9.53325 1.46675 6.66675C1.46675 3.80025 3.80025 1.46675 6.66675 1.46675C9.53325 1.46675 11.8667 3.80025 11.8667 6.66675C11.8667 9.53325 9.53325 11.8667 6.66675 11.8667ZM6.66675 0.166748C5.81316 0.166748 4.96792 0.334876 4.17931 0.661531C3.39069 0.988187 2.67413 1.46697 2.07055 2.07055C0.851567 3.28954 0.166748 4.94284 0.166748 6.66675C0.166748 8.39065 0.851567 10.044 2.07055 11.2629C2.67413 11.8665 3.39069 12.3453 4.17931 12.672C4.96792 12.9986 5.81316 13.1667 6.66675 13.1667C8.39065 13.1667 10.044 12.4819 11.2629 11.2629C12.4819 10.044 13.1667 8.39065 13.1667 6.66675C13.1667 5.81316 12.9986 4.96792 12.672 4.17931C12.3453 3.39069 11.8665 2.67413 11.2629 2.07055C10.6594 1.46697 9.94281 0.988187 9.15419 0.661531C8.36557 0.334876 7.52034 0.166748 6.66675 0.166748M6.01675 9.91675H7.31675V6.01675H6.01675V9.91675Z"
                fill="#FFC702"
              />
            </svg>
          </button>
        </div>
        <p className="w-25 mb-0 fs-sm fw-medium text-center">
          {horario_creditos}: {creditos}{" "}
        </p>
      </div>
    </div>
  );
};

export default RowAsignatura;
